// dependencies
import { isImmutable } from "immutable";

// actions
import { displayWarning } from "../../actions/notifications.actions";

/**
 * Will display warnings if a response contains any.
 */
const WarningsMiddleware = (store) => (next) => (action) => {
	const { dispatch } = store;
	const { type, response } = action;

	const isRequestResponse = type.indexOf("@FAIL") >= 0 || type.indexOf("@SUCCESS") >= 0;

	if (isRequestResponse && isImmutable(response)) {
		const warningMessage = response.getIn(["warnings", 0, "message"], null);

		if (warningMessage) {
			dispatch(displayWarning(warningMessage));
		}
	}

	/*
        next() passes an action to the next middleware, or to the
        reducer if there's no next middleware.
    */
	next(action);
};

export default WarningsMiddleware;
